class CollectionTabsProducts extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    this.tabsContainer = this.querySelector('.collection-tabs-products__tabs');
    this.isDragging = false;
    this.touchStartX = 0;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });

    if (this.tabsContainer) {
      this.tabsContainer.addEventListener('touchstart', this.onTabsTouchStart.bind(this), { passive: true });
      this.tabsContainer.addEventListener('touchmove', this.onTabsTouchMove.bind(this), { passive: true });
      this.tabsContainer.addEventListener('touchend', this.onTabsTouchEnd.bind(this));
    }
  }

  onTabsTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
    this.isDragging = false;
  }

  onTabsTouchMove(event) {
    if (Math.abs(event.touches[0].clientX - this.touchStartX) > 8) {
      this.isDragging = true;
    }
  }

  onTabsTouchEnd() {
    window.setTimeout(() => {
      this.isDragging = false;
    }, 0);
  }

  onTabClick(event) {
    if (this.isDragging) {
      event.preventDefault();
      return;
    }

    const tab = event.currentTarget;
    const targetId = tab.getAttribute('aria-controls');
    if (!targetId) return;

    this.tabs.forEach((item) => {
      const isActive = item === tab;
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.classList.toggle('is-active', isActive);
    });

    this.scrollTabIntoView(tab);

    this.panels.forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.hidden = !isActive;

      if (!isActive) return;

      const slider = panel.querySelector('[id^="Slider-"]');
      if (slider) slider.scrollLeft = 0;

      const sliderComponent = panel.querySelector('slider-component');
      if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
        sliderComponent.resetPages();
      }
    });
  }

  scrollTabIntoView(tab) {
    if (!this.tabsContainer) return;

    const containerRect = this.tabsContainer.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();
    const offset = 16;

    if (tabRect.left < containerRect.left) {
      this.tabsContainer.scrollTo({
        left: this.tabsContainer.scrollLeft + tabRect.left - containerRect.left - offset,
        behavior: 'smooth',
      });
    } else if (tabRect.right > containerRect.right) {
      this.tabsContainer.scrollTo({
        left: this.tabsContainer.scrollLeft + tabRect.right - containerRect.right + offset,
        behavior: 'smooth',
      });
    }
  }
}

customElements.define('collection-tabs-products', CollectionTabsProducts);
